import { useContext } from "react";
import { ModalContext } from "./ModalContext";

function useModal() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error(
      "ModalContext must be used within a ModalContextProvider"
    );
  }

  return context;
}

export default useModal;
